import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { Link, useParams } from 'react-router-dom';
import * as pickDropConfig from '../config/city.json';
import React, { useEffect, useState } from 'react';
import Select from "react-dropdown-select";
import getSelfDriveCars from '../config/selfDriveCars';
import * as _ from 'lodash';
import * as charges from '../config/charges.json';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import Collapsible from 'react-collapsible';
import { SuperSEO } from 'react-super-seo';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import CarDetails from './carDetails.component';
import { setHours, setMinutes } from 'date-fns';
import { Fleet } from '../models/cars.model';
import getWithDriverCars from '../config/withDriverCars';
import { Helmet } from 'react-helmet';
import * as seoSelfDrive from '../config/seo-selfdrive.json';
import * as seoSelfDriveBike from '../config/seo-selfdrive-bike.json';
import * as seoWithDriver from '../config/seo-withdriver.json';
import * as seoTourPackages from '../config/seo-tourpackages.json';
import getSelfDriveBikes from '../config/selfDriveBikes';
import getTourPackages from '../config/tourPackages';
import TourPackageDetails from './tourPackageDetails.component';

const CustomDatePickerInput = React.forwardRef(({ value, onClick }: any, ref: any) => (
    <div 
        className="custom-datetime-picker-input form-control d-flex align-items-center justify-content-between" 
        onClick={onClick} 
        ref={ref} 
        style={{ cursor: 'pointer', height: '46px', background: '#fff', border: '1px solid #cbd5e1', borderRadius: '8px', padding: '10px 15px', width: '100%', boxSizing: 'border-box' }}
    >
        <span style={{ color: value ? '#0f172a' : '#64748b', fontSize: '14px', fontWeight: 500 }}>{value || "Select Date & Time"}</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" style={{ color: 'var(--primary-color)', flexShrink: 0 }}>
            <path d="M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z"/>
            <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
        </svg>
    </div>
));

function ServiceFinder() {
    const { serviceType, location } = useParams();
    const isTourPackages = serviceType === 'tour-packages';
    const
        [cover, setCover] = useState<string>(process.env.PUBLIC_URL + '/image/bg_2.jpg'),
        [isLoading, setLoading] = useState<Boolean>(true),
        [isSelfDrive, setIsSelfDrive] = useState<Boolean>(true),
        [isBikeRental, setIsBikeRental] = useState<Boolean>(false),
        [selectedPickup, setPickup] = useState<string>(''),
        [selectedDropoff, setDropoff] = useState<string>(''),
        [pickupPoints, setPickupPoints] = useState<any[]>([]),
        [dropoffPoints, setDropoffPoints] = useState<any[]>([]),
        [totalDays, setTotalDays] = useState<number>(1),
        [pickupDate, setPickupDate] = useState<any>(new Date()),
        [dropoffDate, setDropoffDate] = useState<any>(new Date(new Date().setDate(new Date().getDate() + 1))),
        [serviceLocations, setServiceLocations] = useState<any>(null),
        [travellers, setTravellers] = useState<number>(1);

    const onPickupDateChange = (pickupDate: Date | null) => {
        setPickupDate(pickupDate)
        const nextDate = new Date(pickupDate!);
        setDropoffDate(new Date(new Date(nextDate.setDate(nextDate.getDate() + 1)).setTime(pickupDate!.getTime() + 24 * 60 * 60 * 1000)));
    }

    const getMinDropoffDate = () => {
        const nextDate = new Date(new Date(pickupDate).setTime(pickupDate.getTime() + 24 * 60 * 60 * 1000));
        return new Date(nextDate.setDate(nextDate.getDate()));
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        setIsSelfDrive(['self-driving-car-rental', 'self-driving-bike-rental'].includes(serviceType!));
        setIsBikeRental(['self-driving-bike-rental'].includes(serviceType!));
        setPickAndDrop(_.startCase(location));
        setCoverImage(_.startCase(location));
        setLoading(true);
        let locations = _.pickBy(
            filterByService(pickDropConfig, _.startCase(serviceType!)),
            city => city.config.length > 0
        );
        console.log('Filtered Locations:', locations);
        setServiceLocations(locations);
    }, [serviceType, location]);

    const getSeoConfig = () => {
        if (isTourPackages) {
            return seoTourPackages;
        }
        return isSelfDrive ? (isBikeRental ? seoSelfDriveBike : seoSelfDrive) : seoWithDriver;
    }

    function filterByService(cities: any, serviceType: string) {
        return _.mapValues(cities, city => {
            const filteredConfig = _.filter(city.config, ['service', serviceType]);
            return {
                ...city,
                config: filteredConfig
            };
        });
    }

    const getFleet = (): any[] => {
        if (isTourPackages) {
            return getTourPackages();
        }
        return isSelfDrive ? (isBikeRental ? getSelfDriveBikes() : getSelfDriveCars()) : getWithDriverCars();
    }

    function getTitle(titleType: 'title' | 'heading' | 'banner' = 'title') {
        let seoConfig = getSeoConfig();
        switch (titleType) {
            case 'heading':
                return `Best ${_.startCase(serviceType)} In ${_.startCase(location)}`;
            case 'banner':
                return `${seoConfig[_.startCase(location) as keyof typeof seoConfig].bannerTitle}`;
            default:
                return `${seoConfig[_.startCase(location) as keyof typeof seoConfig].title}`;
        }
    }

    function getDescription() {
        let seoConfig = getSeoConfig();
        return `${seoConfig[_.startCase(location) as keyof typeof seoConfig].description}`;
    }

    function setCoverImage(city: any) {
        let coverImage = pickDropConfig[city as keyof typeof pickDropConfig]?.cover || (process.env.PUBLIC_URL + '/image/bg_2.jpg');
        setCover(coverImage);
    }

    function setPickAndDrop(city: any) {
        let pickupPoints: any[] = [], dropoffPoints: any[] = [];
        const configList = pickDropConfig[city as keyof typeof pickDropConfig]?.config;
        if (configList) {
            configList.forEach((config) => {
                if (config.service === _.startCase(serviceType)) {
                    config.pickup.forEach((pickup, index) => {
                        pickupPoints.push({ id: index, name: pickup })
                    });
                    config.dropoff.forEach((dropoff, index) => {
                        dropoffPoints.push({ id: index, name: dropoff })
                    });
                }
            });
        }
        setPickupPoints(pickupPoints);
        if (pickupPoints.length > 0) setPickup(pickupPoints[0].name);
        setDropoffPoints(dropoffPoints);
        if (dropoffPoints.length > 0) setDropoff(dropoffPoints[0].name);
    }

    function getCanonicalUrl() {
        return `https://www.aapligaadi.co.in/services/${serviceType}/${location}`;
    }

    return (
        <>
            <Helmet>
                <link rel="canonical" href={getCanonicalUrl()} />
            </Helmet>
            <SuperSEO
                title={`${getTitle()}`}
                description={`${getDescription()}`}
                lang="en"
                openGraph={
                    {
                        ogTitle: `${getTitle()}`,
                        ogDescription: `${getDescription()}`,
                        ogType: 'website',
                        ogUrl: getCanonicalUrl(),
                        ogImage: { ogImage: cover },
                    }
                }
            />
            <div className="hero-wrap " style={{ backgroundImage: `url('${cover}')`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }} data-stellar-background-ratio="0.5">

                <div className="container">
                    <div className="row no-gutters slider-text justify-content-start align-items-center justify-content-center">
                        <div className="col-lg-8 ">
                            <div className="text w-100 text-center mb-md-5 pb-md-5">
                                <h1 className="mb-4">
                                    {
                                        getTitle('banner')
                                    }
                                </h1>
                                <p style={{ fontSize: '18px' }}>
                                    Explore the unexplored with <a href='https://www.aapligaadi.co.in' target={'_self'}>Aapli Gaadi</a>. Choose from wide range of cars.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <section className="ftco-section ftco-no-pt bg-light">
                <div className="container">
                    <div className="row no-gutters">
                        <div className="col-md-12 featured-top">
                            <div className="row no-gutters">
                                <div className="row bg-primary" style={{ borderRadius: '15px', padding: '20px', minWidth: '100%' }} id="trip_details">
                                    {isTourPackages ? (
                                        <>
                                            <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                                                <label htmlFor="" className="label">Tour Start Date</label><br />
                                                <DatePicker 
                                                    selected={pickupDate} 
                                                    dateFormat='dd MMM yyyy' 
                                                    onSelect={date => setPickupDate(date)} 
                                                    onChange={date => setPickupDate(date)} 
                                                    minDate={new Date()} 
                                                    customInput={<CustomDatePickerInput />}
                                                    disabledKeyboardNavigation
                                                />
                                            </div>
                                            <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                                                <label htmlFor="" className="label">Number of Travellers</label><br />
                                                <input 
                                                    type="number" 
                                                    className="form-control" 
                                                    min={1} 
                                                    value={travellers} 
                                                    onChange={(e) => setTravellers(parseInt(e.target.value) || 1)} 
                                                    style={{ height: '40px' }}
                                                />
                                            </div>
                                            <div className='col-md-4'></div>
                                            <div className="col-md-4 align-items-center">
                                                <br />
                                                <a href="#cars" className="btn btn-secondary py-3 px-4 form-control">Explore Tour Packages</a>
                                            </div>
                                            <div className='col-md-4'></div>
                                        </>
                                    ) : (
                                        <>
                                            <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                                                <label htmlFor="" className="label">Pick-up location</label>
                                                <Select className={'form-control'} values={[]} labelField='name' searchable={true} valueField='name' options={pickupPoints} onChange={(values) => { setPickup(values[0].name) }} />
                                            </div>
                                            <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                                                <label htmlFor="" className="label">Drop-off location</label>
                                                <Select className={'form-control'} values={[]} labelField='name' searchable={true} valueField='name' options={dropoffPoints} onChange={(values) => { setDropoff(values[0].name) }} />
                                            </div>
                                            <div className='col-lg-6 col-md-6 col-sm-6 col-xs-12'>
                                                <label htmlFor="" className="label">Pick-up date</label><br />
                                                <DatePicker 
                                                    selected={pickupDate} 
                                                    showTimeSelect 
                                                    dateFormat='dd MMM yyyy, h:mm a' 
                                                    onSelect={date => onPickupDateChange(date)} 
                                                    onChange={date => onPickupDateChange(date)} 
                                                    minDate={new Date()} 
                                                    customInput={<CustomDatePickerInput />}
                                                    disabledKeyboardNavigation
                                                />
                                            </div>
                                            <div className='col-lg-6 col-md-6 col-sm-6 col-xs-12'>
                                                <label htmlFor="" className="label">Drop-off date</label><br />
                                                <DatePicker 
                                                    selected={dropoffDate} 
                                                    showTimeSelect 
                                                    dateFormat='dd MMM yyyy, h:mm a' 
                                                    onSelect={date => setDropoffDate(date)} 
                                                    onChange={date => setDropoffDate(date)} 
                                                    minDate={isSelfDrive ? getMinDropoffDate() : new Date()} 
                                                    customInput={<CustomDatePickerInput />}
                                                    disabledKeyboardNavigation
                                                />
                                            </div>
                                            <div className='col-md-4'></div>
                                            <div className="col-md-4 align-items-center">
                                                <br />
                                                <a href="#cars" className="btn btn-secondary py-3 px-4 form-control" > {isBikeRental ? 'Rent A Bike Now' : 'Rent A Car Now'}</a>
                                            </div>
                                            <div className='col-md-4'></div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section className="ftco-section ftco-no-pt bg-light" id="cars">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-12 heading-section text-center  mb-5">
                            <h2 className="mb-2">
                                {isTourPackages ? 'Available Tour Packages' : (isBikeRental ? 'Available Bikes' : 'Available Vehicles')}
                            </h2>
                            <h3>{`${getTitle('heading')}`}</h3>
                        </div>
                    </div>
                    {
                        isTourPackages ? (
                            getFleet().length > 0 &&
                            _.filter(getFleet(), (item) => {
                                const locList = item.Locations || item.locations || [];
                                return locList.some((loc: string) => loc.toLowerCase() === location?.toLowerCase());
                            }).map((pkg: any, idx: number) =>
                                <TourPackageDetails 
                                    key={`${location}-${serviceType}-${idx}`} 
                                    packageItem={pkg} 
                                    idx={idx} 
                                    startDate={pickupDate} 
                                    travellers={travellers} 
                                />
                            )
                        ) : (
                            getFleet().length > 0 &&
                            _.filter(getFleet(), (car) => { 
                                const locList = car.Locations || car.locations || [];
                                return locList.some((loc: string) => loc.toLowerCase() === location?.toLowerCase());
                            }).map((vehicle: Fleet, idx: number) =>
                                <CarDetails key={`${location}-${serviceType}-${idx}`} vehicle={vehicle} idx={idx} pickupDate={pickupDate} dropoffDate={dropoffDate} selectedPickup={selectedPickup} selectedDropoff={selectedDropoff} isSelfDrive={isSelfDrive} isBikeRental={isBikeRental} />
                            )
                        )
                    }
                    {
                        _.filter(getFleet(), (item) => { 
                            const locList = item.Locations || item.locations || [];
                            return locList.some((loc: string) => loc.toLowerCase() === location?.toLowerCase());
                        }).length === 0 &&
                        <p className='text-center'><b><i>Sorry, No {isTourPackages ? 'tour packages' : (isBikeRental ? 'bikes' : 'cars')} available at the moment. Please try again later.</i></b></p>
                    }
                    <div className='row'>
                        <div className="col-md-12 heading-section mb-5">
                            <a>
                                <Collapsible trigger={`Aapli Gaadi ${_.startCase(serviceType)} services are also availabe at ${Object.keys(_.omit(serviceLocations, ['default', `${location}`])).join(', ')} locations. (Click to view)`}>
                                    <p><ul>
                                        {
                                            Object.keys(_.omit(serviceLocations, ['default', `${location}`])).map((city, idx) => {
                                                return <li key={idx}><Link to={`/services/${serviceType}/${city.toLowerCase().replace(' ', '-')}`}>{`Best and Affordable ${_.startCase(serviceType)} In ${_.startCase(city)}`}</Link></li>
                                            })
                                        }
                                    </ul>
                                    </p>
                                </Collapsible>
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default ServiceFinder